import request from '../kernel/request'

export default {
	market: {
		page(params) {
			return request.get('market/detail/page', params)
		},
		auditPage(params) {
			return request.get('market/detail/audit/page', params)
		},
		audit(params) {
			return request.put('market/detail/audit', params)
		},
		uploadUrl: `${request.baseURL}/market/detail/uploadLic`,
	},
	staff:{
		list(params) {
			return request.get('staff/account', params)
		},
		page(params) {
			return request.get('staff/account/page', params)
		},
		loadBy(params) {
			return request.get('staff/account/loadBy', params)
		},
		loadList(params) {
			return request.get('staff/account/loadList', params)
		},
		save(data) {
			return request.post('staff/account', data)
		},
		upStaff(data) {
			return request.put('staff/account/upStaff', data)
		},
		update(data) {
			return request.put('staff/account', data)
		},
		load(id) {
			return request.get('staff/account/' + id)
		},
	},
	payShare:{
		page(params) {
			return request.get('pay/share/page', params)
		},
		loadBy(params) {
			return request.get('pay/share/loadBy', params)
		},
		audit(data) {
			return request.put('pay/share/audit', data)
		},
		grant(data) {
			return request.put('pay/share/grant', data)
		},
		uploadUrl: `${request.baseURL}/pay/share/uploadLic`,
	},
	courseIntro:{
		page(params) {
			return request.get('courseIntro/page', params)
		},
		list(params) {
			return request.get('courseIntro/list', params)
		},
		save(data) {
			return request.post('courseIntro', data)
		},
		update(data) {
			return request.put('courseIntro', data)
		},
		load(id) {
			return request.get('courseIntro/' + id)
		},
		delete(id) {
			return request.delete('courseIntro/' + id)
		},
		uploadUrl: `${request.baseURL}/courseIntro/uploadLic`,
	},
	courseMatter:{
		page(params) {
			return request.get('courseMatter/page', params)
		},
		list(params) {
			return request.get('courseMatter/list', params)
		},
		save(data) {
			return request.post('courseMatter', data)
		},
		update(data) {
			return request.put('courseMatter', data)
		},
		load(id) {
			return request.get('courseMatter/' + id)
		},
		delete(id) {
			return request.delete('courseMatter/' + id)
		},
		import(params){
			return request.upload(`/courseMatter/uploadLic`, params)
		},
		uploadUrl: `${request.baseURL}/courseMatter/uploadLic`,
	}
}